<template>
  <section
    id="country-tab-requirements-info"
    class="wrapper-tab-requirements-info"
  >
    <h2 class="subtitle-content">{{
      $t(`${base}.title`, { name: country.name })
    }}</h2>

    <div class="wrapper-item-list">
      <div
        v-for="(section, index) in sections"
        :key="index"
        class="item-container"
      >
        <p class="card-subtitle">{{ section.title }}</p>
        <div class="card-container">
          <p>{{ section.description }}</p>
        </div>

        <el-button type="text" size="small" class="show-more" @click="showMore">
          {{ $t(`general.show_more`) }}
        </el-button>
      </div>
    </div>

    <LadSearchReviews :limit="3" />
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchTabRequirementsInfo',
  components: {
    LadSearchReviews: () =>
      import(
        /* webpackChunkName: "lad-search-section-reviews" */ '@/components/pages/search/country/sections/reviews'
      ),
  },
  props: {
    currentTab: { type: String, default: '' },
  },
  data() {
    return {
      base: 'search.country.requirements_info',
    }
  },
  computed: {
    ...mapState('country', {
      country: (state) => ({ name: state.header.name }),
      sections: 'travel_information',
    }),
  },
  watch: {
    currentTab: {
      immediate: true,
      handler(newValue, oldValue) {
        if (process.server) return

        if (newValue === 'requirements_info') {
          this.updateTruncated()
        }
      },
    },
  },
  methods: {
    updateTruncated() {
      // Obtener los elementos a procesar
      const items = document.querySelectorAll('div.card-container')

      // Filtrar solo los truncados
      const truncatedItems = [...items].filter(
        (p) => p.offsetHeight < p.scrollHeight
      )

      // Agregar atributo a los truncados
      truncatedItems.forEach((item) => item.setAttribute('data-truncated', ''))
    },
    showMore(event) {
      const p = event.target.parentNode.previousElementSibling
      if (p) {
        p.removeAttribute('data-truncated')
        p.classList.add('show-all')
      }
    },
  },
}
</script>

<style lang="scss">
section.wrapper-tab-requirements-info {
  .wrapper-item-list {
    grid-template-columns: repeat(2, 1fr);

    .item-container {
      height: auto;
      padding: 20px;

      .card-subtitle {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 10px;
      }
    }
  }

  .show-more {
    display: none;
    padding: 0;
    font-size: 14px;

    & > span {
      padding: 7px 0;
      display: inline-block;
      text-decoration: underline;
    }
  }

  .card-container {
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-style: italic;

    &[data-truncated] + .show-more {
      display: inline;
    }

    &.show-all {
      display: inline-block;
    }
  }

  .wrapper-section-reviews {
    padding: 20px 0;

    .subtitle-reviews {
      font-size: 24px;
      text-align: left;
      margin-bottom: 40px;
    }
  }

  @media screen and (max-width: 768px) {
    .reviews-grid {
      padding: 10px 0;
    }

    .wrapper-item-list {
      grid-template-columns: 1fr;

      .item-container {
        .card-subtitle {
          font-size: 18px;
        }
      }
    }

    .wrapper-section-reviews {
      .subtitle-reviews {
        font-size: 18px;
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
